import React, { useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = 'https://newsletter.dizycommerce.com.br/api';

const RegisterTemplate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  
  // Pega os parâmetros da URL de forma segura usando hooks do React Router
  const storeId = searchParams.get('id');
  const storeName = searchParams.get('nome')?.replace(/_/g, ' ') || 'Loja';

  // Estado inicial dos campos do template
  const [formData, setFormData] = useState({
    head: '<link rel="stylesheet" type="text/css" href="../assets/css/newsletter.css"><script type="text/javascript" src="newsletter.js"></script><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="x-apple-disable-message-reformatting"><title></title><style type="text/css"> img {border: 0;}</style>',
    header: '',
    footer: ''
  });

  const [loading, setLoading] = useState(false);

  /**
   * Função para salvar o template no banco de dados
   */
  const handleSave = async () => { 
    if (!storeId) {
        alert("Erro: ID da loja não encontrado. Volte ao dashboard e tente novamente.");
        return;
    }

    const token = sessionStorage.getItem('jwtToken') || 'token_local_teste';

    // Estrutura base necessária para o editor de newsletter funcionar
    const bodyHtml = `
      <center>
        <table id="root" cellpadding="0" cellspacing="0" border="0"></table>
        <table id="table_add_line" width="700" cellpadding="0" cellspacing="0" border="0">
          <tr id="addLine"><td class="adicionar_linhas"></td></tr>
        </table>
      </center>`;

    // Mapeamento dos campos para o que o server.js espera (topheader, header, footer, body)
    const payload = {
      header: `<div class="header">${formData.header}</div>`,
      body: bodyHtml,
      footer: `<div class="footer">${formData.footer}</div>`,
      topheader: formData.head.includes('<head>') 
        ? formData.head.replace(/<head>/g, `<head><link rel="stylesheet" href="newsletter.css">`)
        : `<head><link rel="stylesheet" href="newsletter.css">${formData.head}</head>`
    };

    try {
      setLoading(true);
      
      // Chamada para a rota que criamos no seu backend Node.js
      await axios.post(`${API_URL}/template/add/${storeId}`, payload, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      alert('Template cadastrado com sucesso!');
      navigate('/lojas'); // Redireciona de volta para a listagem de lojas

    } catch (error) {
      console.error("Erro ao salvar:", error);
      alert('Erro ao salvar template. Verifique se o servidor Node (porta 5000) está ligado e se a rota /api/template/add/:storeId existe.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <button onClick={() => navigate(-1)} style={styles.backBtn}>← Voltar</button>
        <div style={styles.titleGroup}>
            <h2 style={styles.title}>Configurar Template</h2>
            <span style={styles.badge}>{storeName} (ID: {storeId})</span>
        </div>
      </header>

      <div style={styles.editorGrid}>
        {/* COLUNA DA ESQUERDA: CAMPOS DE EDIÇÃO */}
        <div style={styles.inputsColumn}>
          <div style={styles.field}>
            <label style={styles.label}>HTML Head (CSS e Meta Tags)</label>
            <textarea 
              value={formData.head}
              onChange={(e) => setFormData({...formData, head: e.target.value})}
              style={styles.textarea}
              placeholder="Ex: <style>.titulo { color: blue; }</style>"
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>HTML Header (Topo do E-mail)</label>
            <textarea 
              value={formData.header}
              onChange={(e) => setFormData({...formData, header: e.target.value})}
              style={styles.textarea}
              placeholder="Cole aqui o HTML do cabeçalho da loja..."
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>HTML Footer (Rodapé do E-mail)</label>
            <textarea 
              value={formData.footer}
              onChange={(e) => setFormData({...formData, footer: e.target.value})}
              style={styles.textarea}
              placeholder="Cole aqui o HTML do rodapé (redes sociais, links úteis)..."
            />
          </div>

          <button 
            onClick={handleSave} 
            style={{
                ...styles.saveBtn, 
                backgroundColor: loading ? '#9ca3af' : '#10b981',
                cursor: loading ? 'not-allowed' : 'pointer'
            }} 
            disabled={loading}
          >
            {loading ? 'Processando...' : 'Finalizar e Salvar Template'}
          </button>
        </div>

        {/* COLUNA DA DIREITA: PREVIEW EM TEMPO REAL */}
        <div style={styles.previewColumn}>
          <h3 style={styles.label}>Pré-visualização do Layout</h3>
          <div style={styles.previewBox}>
            {/* O conteúdo é injetado dinamicamente conforme você digita */}
            <div dangerouslySetInnerHTML={{ __html: formData.header }} />
            
            <div style={styles.bodyPlaceholder}>
                <p style={{margin: 0, fontWeight: 'bold'}}>--- Área de Edição da Newsletter ---</p>
                <p style={{fontSize: '12px', marginTop: '5px'}}>Aqui é onde você arrastará as imagens no próximo passo.</p>
            </div>

            <div dangerouslySetInnerHTML={{ __html: formData.footer }} />
          </div>
        </div>
      </div>
    </div>
  );
};

// ESTILIZAÇÃO (CSS-in-JS)
const styles = {
  container: { 
    padding: '40px', 
    backgroundColor: '#f8fafc', 
    minHeight: '100vh', 
    fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif' 
  },
  header: { 
    display: 'flex', 
    alignItems: 'center', 
    gap: '20px', 
    marginBottom: '40px',
    borderBottom: '1px solid #e2e8f0',
    paddingBottom: '20px'
  },
  titleGroup: { display: 'flex', flexDirection: 'column' },
  title: { margin: 0, fontSize: '24px', color: '#1e293b' },
  badge: { fontSize: '14px', color: '#64748b', fontWeight: '500' },
  backBtn: { 
    padding: '10px 20px', 
    cursor: 'pointer', 
    borderRadius: '8px', 
    border: '1px solid #cbd5e1', 
    backgroundColor: '#fff', 
    fontWeight: '600',
    color: '#475569',
    transition: 'all 0.2s'
  },
  editorGrid: { 
    display: 'grid', 
    gridTemplateColumns: '1.2fr 1fr', 
    gap: '40px',
    maxWidth: '1400px',
    margin: '0 auto'
  },
  inputsColumn: { display: 'flex', flexDirection: 'column', gap: '25px' },
  field: { display: 'flex', flexDirection: 'column', gap: '8px' },
  label: { 
    fontSize: '12px', 
    fontWeight: '800', 
    color: '#64748b', 
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  textarea: { 
    height: '160px', 
    padding: '15px', 
    borderRadius: '12px', 
    border: '1px solid #cbd5e1', 
    fontFamily: 'Consolas, Monaco, monospace', 
    fontSize: '13px', 
    resize: 'vertical',
    outlineColor: '#3b82f6',
    boxShadow: 'inset 0 2px 4px 0 rgba(0,0,0,0.05)'
  },
  saveBtn: { 
    padding: '18px', 
    color: 'white', 
    border: 'none', 
    borderRadius: '12px', 
    fontWeight: '700', 
    fontSize: '16px', 
    boxShadow: '0 10px 15px -3px rgba(16, 185, 129, 0.2)',
    transition: 'transform 0.1s active'
  },
  previewColumn: { 
    backgroundColor: 'white', 
    padding: '30px', 
    borderRadius: '20px', 
    boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)',
    border: '1px solid #e2e8f0',
    alignSelf: 'start'
  },
  previewBox: { 
    border: '1px solid #f1f5f9', 
    minHeight: '600px', 
    borderRadius: '10px', 
    overflow: 'hidden',
    marginTop: '15px',
    backgroundColor: '#fff'
  },
  bodyPlaceholder: { 
    padding: '80px 20px', 
    textAlign: 'center', 
    backgroundColor: '#f8fafc', 
    borderTop: '2px dashed #e2e8f0', 
    borderBottom: '2px dashed #e2e8f0', 
    color: '#94a3b8' 
  }
};

export default RegisterTemplate;
